let url = 'https://api.winderinfo.com' //网络请求的地址

export default url